/* merme-shop-filters — old-site filter behaviour on the Merme collection grid:
   FILTER button opens a LEFT sidebar with every group expanded; changes apply
   instantly via the Section Rendering API (grid + group counts swap in place,
   the panel stays open). Sort select lives in the toolbar and uses the same
   fetch path. */
(function () {
  if (customElements.get('merme-shop-filters')) return;

  class MermeShopFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.collectionUrl = this.dataset.collectionUrl || window.location.pathname;
      // Generalized for the gifting widget: configurable swap target, optional
      // history writes (the gifting page keeps its own ?g=&sub= URL).
      this.gridSel = this.dataset.target || '#ProductGridContainer';
      this.useHistory = this.dataset.history !== 'false';
      this.overlay = this.querySelector('.msf__overlay');
      this.form = this.querySelector('[data-msf-form]');
      this.sort = this.querySelector('[data-msf-sort]');
      this.priceTimer = null;

      // Inside the gifting widget the element lives in the <form data-gg-block>
      // (its own filter container is a <div> to avoid nested forms). Stop Enter
      // in a price input from GET-submitting the host form.
      const host = this.closest('form');
      if (host) host.addEventListener('submit', (e) => e.preventDefault());

      this.querySelectorAll('[data-msf-open]').forEach((b) =>
        b.addEventListener('click', () => this.toggle(true))
      );
      this.querySelectorAll('[data-msf-close]').forEach((b) =>
        b.addEventListener('click', () => this.toggle(false))
      );
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.overlay && this.overlay.classList.contains('is-open')) this.toggle(false);
      });

      if (this.form) {
        this.form.addEventListener('submit', (e) => e.preventDefault());
        this.form.addEventListener('input', (e) => {
          const t = e.target;
          if (t.matches('[data-msf-collection]')) return; // handled on change
          if (t.matches('.msf__price-input')) {
            clearTimeout(this.priceTimer);
            this.priceTimer = setTimeout(() => this.apply(), 500);
          } else if (t.matches('input[type="checkbox"]')) {
            this.apply();
          }
        });
        this.form.addEventListener('change', (e) => {
          const sel = e.target.closest('[data-msf-collection]');
          if (sel && sel.value) window.location.href = sel.value; // collection switch = navigation
        });
      }
      if (this.sort) this.sort.addEventListener('change', () => this.apply());

      const clear = this.querySelector('[data-msf-clear]');
      if (clear) {
        clear.addEventListener('click', (e) => {
          e.preventDefault();
          this.apply(true);
        });
      }

      // The gift widget's animated containers create transformed ancestors that
      // hijack position:fixed (overlay sizes to the widget box, backdrop dies).
      // Portal the overlay to <body> — all msf CSS is flat class selectors, so
      // styling survives; listeners were bound above so refs stay live.
      if (this.overlay) document.body.appendChild(this.overlay);
    }

    disconnectedCallback() {
      if (this.overlay) this.overlay.remove();
    }

    toggle(open) {
      if (!this.overlay) return;
      this.overlay.classList.toggle('is-open', open);
      this.overlay.setAttribute('aria-hidden', String(!open));
      document.documentElement.classList.toggle('msf-no-scroll', open);
      const trigger = this.querySelector('[data-msf-open]');
      if (trigger) trigger.setAttribute('aria-expanded', String(open));
    }

    params(cleared) {
      const params = new URLSearchParams();
      if (!cleared && this.form) {
        if (this.form instanceof HTMLFormElement) {
          new FormData(this.form).forEach((val, key) => {
            if (String(val).trim() !== '') params.append(key, val);
          });
        } else {
          // <div data-msf-form> variant (gifting): collect named inputs manually
          this.form.querySelectorAll('input[name], select[name]').forEach((el) => {
            if (el.type === 'checkbox' || el.type === 'radio') {
              if (el.checked) params.append(el.name, el.value);
            } else if (String(el.value).trim() !== '') {
              params.append(el.name, el.value);
            }
          });
        }
      }
      if (this.sort && this.sort.value) params.set('sort_by', this.sort.value);
      return params;
    }

    apply(cleared) {
      const params = this.params(cleared);
      const grid = document.querySelector(this.gridSel);
      if (grid) grid.classList.add('msf-loading');
      const qs = params.toString();
      fetch(this.collectionUrl + '?section_id=' + this.sectionId + (qs ? '&' + qs : ''))
        .then((r) => r.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const newGrid = doc.querySelector(this.gridSel);
          if (grid && newGrid) {
            grid.innerHTML = newGrid.innerHTML;
            // section-rendered pagination links may carry section_id — scrub it
            grid.querySelectorAll('a[href*="section_id="]').forEach((a) => {
              const u = new URL(a.getAttribute('href'), window.location.origin);
              u.searchParams.delete('section_id');
              a.setAttribute('href', u.pathname + u.search + u.hash);
            });
          }
          const groups = (this.overlay || this).querySelector('[data-msf-groups]');
          const newGroups = doc.querySelector('[data-msf-groups]');
          if (groups && newGroups) groups.innerHTML = newGroups.innerHTML;
          if (this.useHistory) history.replaceState(null, '', this.collectionUrl + (qs ? '?' + qs : ''));
          // swapped-in cards need their saved wishlist state repainted
          if (window.MermeWishlist && window.MermeWishlist.paint) window.MermeWishlist.paint();
        })
        .catch(() => {})
        .finally(() => {
          if (grid) grid.classList.remove('msf-loading');
        });
    }
  }

  customElements.define('merme-shop-filters', MermeShopFilters);
})();
